const comments = [
  { name: '吃瓜不嫌事大', time: '2小时前', text: '这个站更新是真的快，昨天的爆料今天首页就上了，比我自己刷微博还及时，果断收藏了！', tag: '铁粉' },
  { name: '深夜追瓜人', time: '5小时前', text: '找了好几个吃瓜入口都失效了，没想到这里还稳定更新，APP也装了，再也不怕迷路。', tag: '新瓜友' },
  { name: '八卦研究员', time: '8小时前', text: '内容分类做得不错，娱乐圈和网红圈分得很清楚，找瓜效率高了很多，推荐给同事了。', tag: '活跃用户' },
  { name: '低调围观群众', time: '12小时前', text: '朋友推荐过来的，界面干净没有乱七八糟的广告，吃瓜体验很好，希望一直保持下去。', tag: '推荐用户' },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">读者热议</h2>
            <p className="text-sm text-foreground-500">吃瓜群众真实反馈，好评如潮</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {comments.map((c, i) => (
              <div key={i} className="bg-background-50 rounded-lg p-5 border border-background-300/40 hover:border-background-300/70 transition-all duration-200">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 rounded-full bg-secondary-500/20 flex items-center justify-center">
                    <span className="text-xs font-medium text-secondary-400">{c.name[0]}</span>
                  </div>
                  <div>
                    <h3 className="text-sm font-medium text-foreground-800">{c.name}</h3>
                    <span className="text-xs text-foreground-400">{c.time}</span>
                  </div>
                  <span className="ml-auto text-[10px] px-2 py-0.5 rounded-full bg-accent-500/15 text-accent-400">{c.tag}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{c.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}